export default __webpack_public_path__ + "static/media/4bf608e8b337e686.4bd82d111bea46126e456d3b88a8a2a3.svg";